import useModal from 'src/components/Modals/hooks/useModal';
import ExportHistoryModal from 'src/components/Modals/ExportHistoryModal/ExportHistoryModal';
import NetFundingHistoryModal from 'src/components/Modals/NetFundingHistoryModal';
import UserSurvey from 'src/components/UserSurvey/UserSurvey';

export default function UserModals() {
	const { currentModal } = useModal();
	return (
		<>
			{currentModal?.type === 'export_history' && (
				<ExportHistoryModal {...currentModal.props} />
			)}
			{currentModal?.type === 'net_funding_history' && (
				<NetFundingHistoryModal {...currentModal.props} />
			)}
			{currentModal?.type === 'user_survey' && (
				<UserSurvey {...currentModal.props} />
			)}
		</>
	);
}
